import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { createdATFilter, fragileFilter, needRefrigerationFilter } from 'modules/common/constants';
import { getProviderLogisticFilter } from 'modules/common/constants/filters';
import { transformWhitObjectId } from 'modules/common/constants/object-id';
import { DISTRIBUTION_CENTERS_LIST_KEY } from 'modules/inventory/distribution-centers/constants';
import { DistributionCentersService } from 'modules/inventory/distribution-centers/services';
import { codeFilter } from 'modules/inventory/product/constants';
import { WAREHOUSES_LIST_KEY } from 'modules/inventory/warehouse/constants';
import { WarehouseService } from 'modules/inventory/warehouse/services';
import { quantityFilter } from 'modules/reports/constants/filters/report-stock-activity.filters';
import { orderVolumeFilter, orderWeightFilter } from 'modules/sales/common/constants/order-filters';
import { DISPATCH_STATUS_ENUM } from './dispatch.enum';
import { addressFilters } from 'lib/dfl-address-filter';
import { supplierFilter } from 'modules/inventory/provider/supplier/constants';
import { CategoryService } from 'modules/inventory/settings/category/services';
import { CATEGORIES_LIST_KEY } from 'modules/inventory/settings/category/constants';

export const dispatchStatusFilter: Filter = {
  filter: 'common:status',
  translate: true,
  key: 'status',
  field: 'status',
  type: FilterType.FIXED_LIST,
  options: Object.keys(DISPATCH_STATUS_ENUM)?.map((status) => ({
    value: status,
    translate: true,
    label: `dispatch:status.${status}`,
  })),
};

export const dispatchSuborderCountFilter: Filter = {
  filter: 'dispatch:fields.metrics.suborderCount',
  translate: true,
  type: FilterType.NUMBER,
  key: 'suborderCount',
  field: 'metrics.suborderCount',
};

const dispatchAddressFilter = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'address.country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'metrics.subordersByRegion.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'address.city',
  justUseFor: 'CU',
  hideCity: true,
});

export const dispatchDistributionCenterFilter: Filter = {
  filter: 'distributionCenters:name',
  translate: true,
  key: 'dc',
  field: 'space',
  queryKey: DISTRIBUTION_CENTERS_LIST_KEY,
  type: FilterType.DYNAMIC_LIST,
  fetchOption: { size: 200 },
  fetchFunc: DistributionCentersService.search,
};

export const dispatchFilters = [
  dispatchSuborderCountFilter,
  dispatchStatusFilter,
  dispatchDistributionCenterFilter,
  ...dispatchAddressFilter,
  createdATFilter,
];

export const warehouseFilter: Filter = {
  filter: 'common:warehouse',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  key: 'warehouse',
  labelKey: 'name',
  field: 'warehouse._id',
  fetchFunc: WarehouseService.search,
  fetchOption: { size: 200 },
  queryKey: WAREHOUSES_LIST_KEY,
  transform: (value) => transformWhitObjectId(value, 'warehouse._id'),
};

const logisticFilter = getProviderLogisticFilter('warehouse.logistic._id');

const productsFilter: Filter = {
  filter: 'breadcrumb:products',
  translate: true,
  type: FilterType.NUMBER,
  key: 'products',
  field: 'products',
};

export const warehouseFragileFilter = {
  filter: 'product:fragileProducts',
  translate: true,
  type: FilterType.NUMBER,
  key: 'fragile',
  field: 'fragile',
};

export const warehouseNeedRefrigerationFilter = {
  filter: 'product:refrigeratedProducts',
  translate: true,
  type: FilterType.NUMBER,
  key: 'ref',
  field: 'needRefrigeration',
};

export const categoryFilter: Filter = {
  filter: 'product:fields.category',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  key: 'category',
  labelKey: 'name',
  field: 'category._id',
  fetchFunc: CategoryService.search,
  fetchOption: { size: 200 },
  queryKey: CATEGORIES_LIST_KEY,
  transform: (value) => transformWhitObjectId(value, 'category._id'),
};

export const dispatchProductFilters = [
  codeFilter(),
  quantityFilter,
  warehouseFilter,
  supplierFilter,
  categoryFilter,
  orderWeightFilter,
  orderVolumeFilter,
  fragileFilter,
  needRefrigerationFilter,
];

export const dispatchWarehouseFilters = [
  warehouseFilter,
  logisticFilter,
  productsFilter,
  quantityFilter,
  orderWeightFilter,
  orderVolumeFilter,
  warehouseFragileFilter,
  warehouseNeedRefrigerationFilter,
];
